import { z } from 'zod';

export const feedbackSubmissionTypeSchema = z.enum(['bug', 'feature_request']);

export const feedbackSubmitFormSchema = z.object({
  submissionType: feedbackSubmissionTypeSchema,
  message: z
    .string()
    .trim()
    .min(1, 'Enter a short description first.')
    .max(10000, 'Description must be 10,000 characters or fewer.'),
});

export type FeedbackSubmitFormValues = z.infer<typeof feedbackSubmitFormSchema>;
